import React from "react";

const Tag = ({ tag }) => {
  return (
    <div className="displayTag">
      <p>{tag}</p>
    </div>
  );
};

export default Tag;
